import React, { useState } from 'react';
import api from '../api';
import { Search, Loader2, Sparkles } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const NLQueryBox = () => {
  const [query, setQuery] = useState('');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!query.trim()) return;
    setLoading(true);
    setError('');
    setResult(null);
    try {
      const res = await api.post('/analytics/nlq', { question: query.trim() });
      setResult(res.data);
    } catch (err) {
      setError(err.response?.data?.detail || 'Có lỗi xảy ra khi xử lý câu hỏi');
    } finally {
      setLoading(false);
    }
  };

  const suggestions = [
    'Hôm nay có bao nhiêu hội thoại?',
    'Nhân viên nào có thời gian phản hồi nhanh nhất?',
    'Tỷ lệ sentiment tiêu cực tuần này?',
    'Top 5 vấn đề khách hàng phàn nàn nhiều nhất?',
  ];

  return (
    <div className="card">
      <div className="flex items-center gap-2 mb-4">
        <Sparkles className="w-5 h-5 text-blue-600" />
        <h3 className="font-semibold text-gray-800">Hỏi đáp thông minh (NLQ)</h3>
      </div>

      <form onSubmit={handleSubmit} className="flex gap-2 mb-3">
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Hỏi bất kỳ điều gì về dữ liệu CSKH..."
          className="input-field flex-1"
        />
        <button type="submit" disabled={loading} className="btn-primary flex items-center gap-2">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Search className="w-4 h-4" />}
          Hỏi
        </button>
      </form>

      <div className="flex flex-wrap gap-2 mb-4">
        {suggestions.map((s, i) => (
          <button
            key={i}
            onClick={() => setQuery(s)}
            className="text-xs bg-blue-50 text-blue-600 px-3 py-1.5 rounded-full hover:bg-blue-100 transition-colors"
          >
            {s}
          </button>
        ))}
      </div>

      <AnimatePresence>
        {error && (
          <motion.div initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }} className="p-3 bg-red-50 text-red-600 rounded-xl text-sm">
            {error}
          </motion.div>
        )}
        {result && (
          <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }} className="space-y-3">
            <div className="p-4 bg-blue-50 rounded-xl">
              <p className="text-sm font-medium text-blue-800 mb-1">Trả lời:</p>
              <p className="text-sm text-blue-700 whitespace-pre-wrap">{result.answer}</p>
            </div>
            {result.sql_query && (
              <details className="text-xs">
                <summary className="cursor-pointer text-gray-400 hover:text-gray-600">Xem SQL query</summary>
                <pre className="mt-2 p-3 bg-gray-900 text-green-400 rounded-xl overflow-x-auto">{result.sql_query}</pre>
              </details>
            )}
            {result.data && result.data.length > 0 && (
              <div className="overflow-x-auto">
                <table className="w-full text-xs">
                  <thead>
                    <tr className="border-b border-gray-200">
                      {Object.keys(result.data[0]).map((k) => (
                        <th key={k} className="text-left py-2 px-3 font-medium text-gray-500">{k}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {result.data.slice(0, 20).map((row, i) => (
                      <tr key={i} className="border-b border-gray-50">
                        {Object.values(row).map((v, j) => (
                          <td key={j} className="py-2 px-3 text-gray-700">{String(v)}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default NLQueryBox;
